import { CreditNoteDTO, CreditNoteLineDTO } from 'returnCenter-api';
import { orderApi } from './api';
import { getLanguage } from './languageStore';

// Re-export generated types for convenience
export type { CreditNoteDTO, CreditNoteLineDTO };

/**
 * Credit Note service - handles credit note API calls
 * Uses OrderApi.orderGetCreditNote endpoint
 */
export const creditNoteService = {
    /**
     * Get credit note details by order number.
     * Note: marketId is sent automatically via the X-Market-Id header in the axios interceptor.
     */
    getCreditNote: async (orderNumber: string): Promise<CreditNoteDTO> => {
        const response = await orderApi.orderGetCreditNote({ language: getLanguage(), orderNumber });
        return response.data;
    },
};
